import { render, staticRenderFns } from "./app-expense.vue?vue&type=template&id=b5619386&scoped=true&"
import script from "./app-expense.vue?vue&type=script&lang=js&"
export * from "./app-expense.vue?vue&type=script&lang=js&"
import style0 from "./app-expense.vue?vue&type=style&index=0&id=b5619386&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5619386",
  null
  
)

export default component.exports